// src/components/atoms/Container/Container.tsx
import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import * as styles from '@/components/Layouts/Container/Container.css';

export interface ContainerProps {
  /** 자식 컴포넌트 */
  children: ReactNode;
  /** 최대 너비: sm / md / lg / xl / max */
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'max';
  /** 상하 패딩 */
  paddingY?: 'none' | 'sm' | 'md' | 'lg';
  /** 좌우 패딩 */
  paddingX?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
  /** (옵션) 가운데 정렬 여부 */
  center?: boolean;
  /** 컨테이너 높이 */
  role?: 'student' | 'academy' | 'admin';
}

export const Container: React.FC<ContainerProps> = ({
  children,
  size = 'xl',
  paddingY = 'none',
  paddingX = 'xl',
  center = true,
  role,
}) => {
  const { pathname } = useLocation();
  
  // 라우터에 따라 role 자동 설정
  const getRoleFromPath = () => {
    if (pathname.includes('/academy/')) return 'academy';
    if (pathname.includes('/admin/')) return 'admin';
    if (pathname.includes('/student/')) return 'student';
    return 'student'; // 기본값
  };
  
  const containerRole = role || getRoleFromPath();
  return (
    <div
      className={styles.container({
        size,
        paddingY,
        paddingX,
        center,
        role: containerRole,
      })}
    >
      {children}
    </div>
  );
};

export default Container;